async function devtricker_ajax_getComments(commentId, offset) {
    try {
        let postId = devtricker_getThePostId();
        let depth =  commentId == 0 ? 0 : devtricker_calculateCommentDepth(`#li-comment-${commentId}`);
        const url = `/wp-admin/admin-ajax.php?action=devtricker_action_load_comments_ajax&comment_id=${encodeURIComponent(commentId)}&offset=${offset}&post_id=${postId}&order_by=${g_devtricker_comment_order_by}&depth=${depth}`;

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const htmlContent = await response.text();
        let tmp = document.createElement('div');
        tmp.innerHTML = htmlContent;

        let comments = Array.from(tmp.querySelectorAll('.comment'));

        const hasNext = response.headers.get('X-Has-Next') === 'true';
        const remainingComments = parseInt(response.headers.get('X-Remaining-Comments'), 10);

        devtricker_log(null, `Loaded comments for post ID ${postId} with offset ${offset}. Retrieved ${comments.length} comments. Has next page: ${hasNext}. Remaining comments to load: ${remainingComments}`);

        return {
            comments: comments,
            hasNext: hasNext,
            remainingComments: remainingComments
        };

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}